export default __webpack_public_path__ + "static/media/email.a49ac80a.svg";